import styled from "styled-components";
import StarIcon from "./goldstar.png"
import KafraImage from "./kafraChibi.png"
import { OpenPopMenu } from "../PopMenuWindow/PopMenuWindow";
import { useContext } from "react";
import { PageContext } from "../Context/PageContext";
import TopRagnarok from "../VoteBanners/TopRagnarok";
import TopRagnarokBrasil from "../VoteBanners/TopRagnarokBrasil";

function VoteWidgetMobile() {

    const {setPopMenuContent} = useContext(PageContext)

    return(
        <MastContainer onClick={
            () => {
                OpenPopMenu();
                setPopMenuContent(
                <LinksContainer>
                    <TopRagnarok />
                    <TopRagnarokBrasil />
                </LinksContainer>
                );
            }
        }>
            <KafraIcon/>
            <MastTitleContainer>
                <Icon/>
                <Text>Vote no servidor</Text>
            </MastTitleContainer>
        </MastContainer>
    )
}

export default VoteWidgetMobile;

const MastContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 10vh;
    left: 25vw;
    z-index: 20;
    padding: 10px 10px;
    border-radius: 5px;
    opacity: .8;
    transition: .3s ease-in-out;
    cursor: url('cursors0007.png'), pointer;
    scale: 1.5;
    margin-top: 100px;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
    

    &:hover{
        opacity: 1;
        scale: 1.5;
    }
`

const LinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 10px;
    border-radius: 10px;
    border: 1px solid black;
    background-color: rgba(19, 19, 20, 1);
`

const MastTitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 5px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 5px;
`

const Text = styled.span`
    color: rgba(255, 255, 255, 1);
    font-size: 12pt;
    font-family: "Arial";
    font-weight: bold;
    margin-right: 10px;
    
`
const Icon = styled.div`
    background-image: url(${StarIcon});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 5px;
`

const KafraIcon = styled.div`
    background-image: url(${KafraImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 100px;
    height: 110px;
    margin-bottom: 0px;
`
